<template>
    <div class="wrap-dashboard">
        <div class="main-content">
            <div class="wrap-content">
                <div class="title-page">Detail IBOSS Permission</div>
                <div class="d-flex justify-content-between">
                    <div class="filter">
                        <label class="label-input"><b>Permission</b> </label>
                        <div class="wrap-input">
                            <label class="label-input">Company Name</label>
                            <span>:</span>
                            <span>{{ dataPermission.nama_persh }}</span>
                        </div>
                        <div class="wrap-input">
                            <label class="label-input">Register No</label>
                            <span>:</span>
                            <span>{{ dataPermission.no_pendaftaran }}</span>
                        </div>
                        <div class="wrap-input">
                            <label class="label-input"> License Number</label>
                            <span>:</span>
                            <span>{{ dataPermission.no_ijin }}</span>
                        </div>
                    </div>
                    <div>
                        <button type="button" class="btn btn-primer" @click="showModal">Add Document</button>
                    </div>
                </div>
                <div class="content">
                    <table>
                        <thead>
                            <tr id="top">
                                <th scope="col" style="width: 70px">No</th>
                                <th scope="col">HS Code</th>
                                <th scope="col">Item Specification</th>
                                <th scope="col">Volume</th>
                                <th scope="col">Remaining Volume</th>
                                <th scope="col">Unit</th>
                                <th scope="col">Original State</th>
                                <th scope="col">Destination Port</th>
                                <th scope="col">Description</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(data, i) in dataCommodity" :key="i">
                                <td data-label="No">{{ i + 1 }}</td>
                                <td data-label="HS Code">{{ data.hs }}</td>
                                <td data-label="item Specification">{{ data.uraian }}</td>
                                <td data-label="Volume">{{ data.kuota }}</td>
                                <td data-label="Volume">{{ data.sisa_kuota.toFixed(5) }}</td>
                                <td data-label="Unit">{{ data.satuan }}</td>
                                <td data-label="Original State">{{ data.kode_negara_asal }}</td>
                                <td data-label="Destionation Port">{{ data.kd_pelabuhan_tujuan }}</td>
                                <td data-label="Description">{{ data.keterangan }}</td>
                                <td data-label="Action">
                                    <router-link :to="'/permission-detail/' + dataPermission.id_ijin + '/' + data.seri">
                                        <b-button variant="outline-info" size="sm" class="mb-1"> Realization </b-button>
                                    </router-link>
                                    <router-link :to="'/permission-detail/' + dataPermission.id_ijin + '/history/' + data._id">
                                        <b-button variant="outline-secondary" size="sm" class="mb-1"> History </b-button>
                                    </router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <b-modal ref="add-document" hide-footer title="Add Document FTZ">
                        <div class="d-block text-left">
                            <form action="">
                                <div class="form-group">
                                    <div>
                                        <label for="" class="label-ftz">PPFTZ</label>
                                        <select name="" id="" class="form-input mb-2" v-model="form_attachment.doc_id">
                                            <option value="" disabled selected>Choose PPFTZ</option>
                                            <option value="240">PIB</option>
                                            <option value="241">PEB</option>
                                        </select>
                                        <br />
                                    </div>
                                    <div class="content-ftz-doc">
                                        <div>
                                            <label for="" class="label-ftz">Input Date</label>
                                            <input
                                                type="date"
                                                name=""
                                                id=""
                                                placeholder="input date input"
                                                v-model="form_attachment.doc_date"
                                                class="form-input mb-2"
                                            />
                                            <br />
                                        </div>
                                        <div>
                                            <label for="" class="label-ftz">Expired Date</label>
                                            <input
                                                type="date"
                                                name=""
                                                id=""
                                                placeholder="input date expired"
                                                v-model="form_attachment.doc_expire"
                                                class="form-input mb-2"
                                            />
                                            <br />
                                        </div>
                                    </div>
                                    <div class="content-ftz-doc">
                                        <div>
                                            <label for="" class="label-ftz">Letter Number</label>
                                            <input
                                                type="text"
                                                name=""
                                                id=""
                                                placeholder="input letter number"
                                                v-model="form_attachment.doc_no"
                                                class="form-input mb-2"
                                            />
                                            <br />
                                        </div>
                                        <div>
                                            <label for="" class="label-ftz">Attachment</label>
                                            <small class="warning">File Must Be .pdf</small>
                                            <div>
                                                <label class="upload-video">
                                                    <span v-if="!loadDataCukai"> <b-icon icon="upload" class="mr-1 icon-upload"></b-icon> Choose File </span>
                                                    <b-spinner small variant="ligth" v-else></b-spinner>
                                                    <input type="file" accept="application/pdf" ref="beaCukai" @change="onBeaCukai" />
                                                </label>
                                                <span id="imageName" class="ml-3"> {{ label_cukai }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <label for="" class="label-ftz">Publisher</label>
                                        <input
                                            type="text"
                                            name=""
                                            id=""
                                            placeholder="input publisher"
                                            v-model="form_attachment.doc_issued"
                                            class="form-input mb-2"
                                        />
                                        <br />
                                    </div>
                                    <div>
                                        <label for="" class="label-ftz">Description</label>
                                        <input
                                            type="text"
                                            name=""
                                            id=""
                                            placeholder="input description"
                                            v-model="form_attachment.description"
                                            class="form-input mb-2"
                                        />
                                        <br />
                                    </div>
                                </div>
                            </form>
                        </div>
                        <!-- <b-alert variant="danger" v-if="status == 422">Please correct your field</b-alert> -->
                        <div class="text-right">
                            <b-button class="mt-3" variant="primary" @click="addDocument">
                                <span v-if="!isLoading">Submit</span>
                                <b-spinner v-else small></b-spinner>
                            </b-button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
export default {
    components: {},
    data() {
        return {
            isLoading: false,
            dataContract: [],
            dataPermission: [],
            dataCommodity: [],
            detailMetal: {},
            currentPage: 1,
            perPage: 10,
            lengthData: 1,
            deposit_id: "",
            offset: 0,
            withdrawal_status: "",
            role: "",
            lenghtDim: "",
            widthDim: "",
            hightDim: "",
            today: "",
            loadindDeposit: false,
            loadDataCukai: false,
            indexForm: null,
            metalInfo: [],
            label_cukai: "",
            form_attachment: {
                id_ijin: "",
                file: "",
                doc_no: "",
                doc_date: "",
                doc_expire: "",
                description: "",
                doc_issued: "",
                doc_id: "",
            },
        };
    },
    mounted() {
        this.today = new Date().toISOString().split("T")[0];
        this.deposit_id = this.$route.params.id;
        axios.get("/v2/attributes/contract").then((res) => {
            this.dataContract = res.data.data.body;
        });

        axios.get("/v2/clearing/admin/abx/get/detail_ijin/" + this.deposit_id).then((res) => {
            this.dataCommodity = res.data.data.komoditas;
            this.dataPermission = res.data.data.ijin;
        });
    },
    methods: {
        checkDecimal(value) {
            if (Number.isInteger(value)) {
                return value;
            } else {
                let lengthDecimal = value.toString().split(".")[1].length;
                let newValue;
                if (lengthDecimal > 5) {
                    newValue = value.toFixed(5);
                } else {
                    newValue = value;
                }
                return newValue;
            }
        },
        onBeaCukai() {
            this.loadDataCukai = true;
            const fileFtz = this.$refs.beaCukai.files[0];
            if (fileFtz.type == "application/pdf") {
                this.requestFormData(fileFtz).then((res) => {
                    this.loadDataCukai = false;
                    this.label_cukai = fileFtz.name;
                    this.form_attachment.file = res.data.data;
                });
            } else {
                this.$toast.error("File type must be .pdf");
                this.loadDataCukai = false;
            }
        },
        requestFormData(fileData) {
            let formData = new FormData();
            formData.append("file", fileData);
            return axios.post("/v2/upload", formData);
        },
        handlePageChange(value) {
            this.getData(value);
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
        getData(value) {
            let offset = (value - 1) * this.perPage;
            console.log(offset);
        },
        showModal() {
            this.$refs["add-document"].show();
        },
        hideModal() {
            this.detailMetal = {};
            this.indexForm = null;
            this.$refs["add-document"].hide();
        },
        addDocument() {
            this.isLoading = true;
            this.form_attachment.id_ijin = this.$route.params.id;
            this.form_attachment.doc_id = Number(this.form_attachment.doc_id);
            axios
                .post("/v2/clearing/admin/abx/upload/document_realisasi", this.form_attachment)
                .then((res) => {
                    if (!res.data.data.iserror) {
                        this.$toast.success("Upload Document Success");
                        setTimeout(() => {
                            location.reload();
                        }, 2000);
                    }
                })
                .catch((error) => {
                    console.log(error.response);
                    this.isLoading = false;
                });
        },
        addDeposite() {
            this.loadindDeposit = true;
            this.$store.dispatch("getLocation").then((resGeo) => {
                if (resGeo.cityData[0]) {
                    this.form.info = JSON.stringify(resGeo);
                } else {
                    let data = resGeo;
                    data.newLatLong = resGeo.cityLatLong.split(",");
                    this.form.info = JSON.stringify(data);
                }
                axios.post("/v2/clearing/admin/abx/deposit", this.form).then((res) => {
                    if (res.data.data.status_code == "00") {
                        this.loadindDeposit = false;
                        this.$toast.success("Add deposit has been successfully submited");
                        this.$router.push("/deposite-onexchange");
                    }
                });
            });
        },
    },
    computed: {
        rows() {
            return (this.currentPage - 1) * this.perPage;
        },
    },
};
</script>

<style scoped>
/*.wrap-dashboard {
  min-height: 100vh;
  margin: 0;
  display: grid;
  grid-template-rows: auto 1fr auto;
}*/

.title-page {
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 40px;
}

.select-input,
input {
    width: 100%;
}

.select-input,
input {
    border-radius: 5px;
    border: 1px solid #454545;
    padding: 0 10px;
    font-size: 13px;
}

.form-label {
    width: 10rem;
}

.dimension:last-child {
    margin-right: unset;
}

#inputTag {
    display: none;
}

input[type="file"] {
    display: none;
}

.warning {
    font-size: 11px;
    color: #aaa;
}

.upload-video {
    border: 1px solid #1f354a;
    padding: 0.5rem;
    color: #1f354a;
    border-radius: 5px;
    font-size: 12px;
    cursor: pointer;
    font-weight: bold;
}

.upload-video:hover {
    background: #1f354a;
    color: #ffffff;
}

.icon-upload {
    font-size: 13px;
}

.form-input {
    width: 100%;
    font-size: 13px;
    border-radius: 5px;
    border: none;
    padding: 0.5rem 1rem;
    box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
}

.form-input:focus {
    border-color: var(--clr-primary);
    outline: 0;
    box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
}

.dimension {
    width: 5.5rem;
    margin-right: 1.5rem;
}

.content {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    justify-content: flex-end;
    margin-top: 15px;
}

.filter {
    display: table-cell;
    width: 40%;
    font-size: 12px;
}
.wrap-input {
    display: flex;
    gap: 0.5rem;
}

.label-input {
    width: 5rem;
}

.buyer,
.seller,
.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.form-attachment .form-input {
    width: 100%;
}

.content-ftz-doc {
    display: flex;
    width: 100%;
    gap: 2rem;
}

.content-ftz-doc div {
    width: 100%;
}

.label-ftz {
    display: block;
    width: 100%;
    font-weight: 500;
    font-size: 13px;
}

.label-form {
    display: block;
    width: 100%;
    font-weight: bold;
}
</style>
